import { html } from 'lit';
import { Plus } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-plus')
export class PdsIconPlus extends PdsIcon {
  @state()
  icon = Plus;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
